import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';
import { DieFace } from '../../face.type';
import { addModifier } from '../../player.type';

export class AnarchistTrait extends Trait {
  static baseType = TraitType.Anarchist;
  static baseTitle = 'Elemental Anarchy';
  static baseText = 'When suffering damage, gain infusion for the damage type.';
  static baseIcon = 'trait';

  type = AnarchistTrait.baseType;
  title = AnarchistTrait.baseTitle;
  text = AnarchistTrait.baseText;
  icon = AnarchistTrait.baseIcon;

  damageIn(damage: any): void {
    if (damage.source == damage.target) {
      var types = [DieFace.Fire, DieFace.Ice, DieFace.Lightning, DieFace.Earth];
      var die = damage.dice.find((die: any) => {
        return types.some((type) => die.value().includes(type));
      });
      if (die) {
        let faces = die.value();
        addModifier(damage.source, StatusEffect.Infusion, 1, { infusion: faces[0] });
      }
    }
  }
}

TraitRegistry.register(AnarchistTrait.baseType, AnarchistTrait);
